import React from "react";
import CustomProject from "../CustomProject";
import "./index.css";

export default function Projects() {
  return (
        <>
      <section className="section projects">
        <div className="section-title">Projects</div>
        <div className="section-content">
          <CustomProject
            title="ItsYoutube"
            link="https://itsmyyoutube.netlify.app/"
            desc=" A youtube clone you can search anything on it , at start the most popular videos you can see on the screen.you can find recommended videos just like youtube related to youtube , Below every search video you can see comments on it ,infinite scroll used for videos and comments on the pages for maximum limit of videos and comments ,until it ends."
            usedArray={[
              "JavaScript",
              "React",
              "Pagination",
              "React Router",
              "Youtube Data API",
            ]}
          />
          <CustomProject
            title=" TVmazeshow"
            link="https://tvmazeshow.vercel.app/"
            desc="A show booking website, where you can see summary of the show and book any show and it will store in the local storage."
            usedArray={[
              "JavaScript",
              "React",
              "React Router",
              "TVmaze API"
            ]}
          />
          <CustomProject
            title="Tallyproducts"
            link="https://tallyproducts.netlify.app/"
            desc="A CRUD app where you can show products information."
            usedArray={[
              "JavaScript",
              "React",
              "React Router",
              "Redux",
              "Bootstrap",
            ]}
          />
          <CustomProject
            title="Notion Clone"
            link="https://8qq97g.csb.app/"
            desc="The key features of this project is that , it is CRUD Application so you can create , read ,update and delete . The tasks starts with heading with bold letters which you can't change its font style but after that ,the font style is of paragraph so you can change it into heading and subheading."
            usedArray={[
              "JavaScript",
              "React",
            ]}
          />
        </div>
      </section>
      <div className="section-content projects-flex">
        <a
          href="https://github.com/Officialthesky"
          className=" underline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>Check my other projects on github.</h4>
        </a>
      </div>
    </>
  );
}